import {ChangeEvent, FC, useCallback} from 'react';
import {useField} from 'formik';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import classNames from 'classnames';

interface RadioProps {
  name: string,
  label: string,
  disabled?: boolean,
  required?: boolean,
  checked?: boolean,
  onChange?: (value: string) => void,
  data: number[],
  defaultValue?: string,
  showLabel: boolean;
}

const RadioFieldGroup: FC<RadioProps> = ({
  name,
  label,
  onChange,
  disabled,
  required,
  data,
  showLabel,
  defaultValue
}) => {
  const [
    {onChange: formikOnChange, checked},
    {error, touched},
    {setTouched}
  ] = useField(name);

  const handleChange = useCallback(
      (event: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
          return onChange(event.target.value);
        }

        setTouched(true);
        formikOnChange(event);
      }, []);

  return (
    <FormControl
      required={required}
      error={!!(touched && error)}
      disabled={disabled}
    >
      <RadioGroup onChange={handleChange} value={defaultValue || checked}>
        <FormLabel>
          <span>
            {label}
            {required && <span className={classNames('asterisk', {'error': touched && error})}>*</span>}
          </span>
        </FormLabel>
        <div className="field-wrapper">
          <div className="radio-wrapper">
            {data.map((item) => {
              return (
                <FormControlLabel
                  value={item}
                  control={<Radio size="small" name={name}/>}
                  label={showLabel && item || ''}
                  disabled={disabled}
                  className="switcher-row"
                  key={item}
                />
              );
            })}
          </div>
          <FormHelperText>{touched && error}</FormHelperText>
        </div>
      </RadioGroup>
    </FormControl>
  );
};

export default RadioFieldGroup;
